import { useEffect } from 'react';


const French = ({ frenchSection }) => {


  if (!frenchSection) return null;

  return (
    <section className="mb-3  bg-french">
      <div className="container">
        <div className="row">
          <h2 className="sec-title text-center">{frenchSection.heading}</h2>
        </div>

        <div className="row align-items-center" >
          {frenchSection.position === 'right' ? (
            <>
              <div className="col-md-6">
                <p style={{ textAlign: 'justify' }}>{frenchSection.content}</p>
              </div>
              <div className="col-md-6">
                <img
                  src={`${process.env.REACT_APP_API_URL}/public${frenchSection.image}`}
                  alt="Why Learn French"
                  className="img-fluid rounded-3"
                />
              </div>
            </>
          ) : (
            <>
              <div className="col-md-6">
                <img
                  src={`${process.env.REACT_APP_API_URL}/public${frenchSection.image}`}
                  alt="Why Learn French"
                  className="img-fluid rounded-3"
                />
              </div>
              <div className="col-md-6">
                <p style={{ textAlign: 'justify' }}>{frenchSection.content}</p>
              </div>
            </>
          )}
        </div>
      </div>
    </section>
  );
};

export default French;
